module.exports = __webpack_public_path__ + "0bbfb38852cf8fd54d3c1a65bad68be5.svg";